module.exports = __webpack_public_path__ + "media/images/logos/certn-logo-bde45c4db760628af89df1163f1342f2.svg";